import { ROUTES } from '@/app/routes';

/** Подстраницы хаба «Лендинги» (BackButton → `/landings`). */
const LANDINGS_HUB_SUBPAGES: readonly string[] = [
	ROUTES.landingsNotification,
	ROUTES.landingsMetaPixels,
	ROUTES.landingsTemplates,
	ROUTES.landingsTelegramAuthTemplates,
	ROUTES.landingsTelegramAuthConstructor,
	ROUTES.landingsDomains,
	ROUTES.landingsSites,
	ROUTES.landingsLinks,
	ROUTES.landingsEvents,
];

export function isLandingsHubSubpage(pathname: string): boolean {
	if (
		pathname === ROUTES.landingsTelegramAuthConstructor ||
		pathname.startsWith(`${ROUTES.landingsTelegramAuthConstructor}/`)
	) {
		return true;
	}
	return LANDINGS_HUB_SUBPAGES.includes(pathname);
}

export function isLandingsDetailPath(pathname: string): boolean {
	return (
		pathname.startsWith(ROUTES.landingsDomain) ||
		isLandingsHubSubpage(pathname) ||
		pathname.startsWith(ROUTES.landingsEvents)
	);
}

/** `null` если pathname не относится к лендингам. */
export function resolveLandingsBackPath(pathname: string): string | null {
	if (pathname.startsWith(ROUTES.landingsDomain)) {
		return ROUTES.landingsDomains;
	}
	if (isLandingsHubSubpage(pathname)) {
		return ROUTES.landings;
	}
	return null;
}
